import { render } from "./SupervisorSingleClaimComponent.vue?vue&type=template&id=0c7b7512&scoped=true"
import script from "./SupervisorSingleClaimComponent.vue?vue&type=script&lang=js"
export * from "./SupervisorSingleClaimComponent.vue?vue&type=script&lang=js"

import "./SupervisorSingleClaimComponent.vue?vue&type=style&index=0&id=0c7b7512&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c7b7512"]])

export default __exports__